import { useState, useContext, useEffect, SetStateAction } from 'react';
import CardHeader from '../../components/CardHeader/index';
import useLoading from '../../../Hooks/useLoading';
import { FileWordOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Loader from '../../../Components/Shared/Loader';
import { OpportunitiesPanelsColumns } from '../../../Static/OpportunitiesPanelsColumns';
import { OpportunitiesPanelsModel, ResultEnum } from '../../../Models/OpportunitiesPanelsModel';
import ModalOpportunitiesPanels from '../../components/modalOpportunitiesPanels';
import { CompanyContext } from '../../../Contexts/CompanyContext';
import useModal from '../../../Hooks/useModal';
import { DeleteOpportunitiesPanelsAPI, GetAllOpportunitiesPanelsAPI, DownloadGrantsDocumentAPI } from '../../../API/OpportunitiesPanelsAPI';
import { IResponseProps } from '../../../Interfaces/IResponseProps';
import { useToast } from '../../../antd/hooks/toast';
import { formatOnlyDate } from '../../../Utils/DateFormat';
import useCan from '../../../Hooks/useCan';
import ModalDelete from '../../../Components/Shared/ModalDelete';
import { PlusOutlined } from '@ant-design/icons';
import { Table } from 'antd';
import { Link } from 'react-router-dom';
import { Button, Typography } from "antd";
import './styles.css';


export default function OpportunitiesPanels() {
    const toast = useToast();
    const { loading, toggleLoading } = useLoading();
    const [total, setTotal] = useState<number>(0);
    const [opportunities, setOpportunities] = useState<OpportunitiesPanelsModel[]>([]);
    const { company } = useContext(CompanyContext);
    const { showModal, toggleShowModal } = useModal();
    const { showModal: showModalDelete, toggleShowModal: toggleShowModalDelete } = useModal();
    const canDelete = useCan({ rolesCan: ["Manager"] });
    const [itemToDelete, setItemToDelete] = useState<string>("");
    const [deleteResponse, setDeleteResponse] = useState<boolean>(false);
    const { Text } = Typography;
    const [take, setTake] = useState(7);
    const [currentPage, setCurrentPage] = useState(1);

    function parseDate(dateString: string) {
        debugger
        const parts = dateString.split('/');
        if (parts.length === 3) {
            const day = parseInt(parts[0], 10);
            const month = parseInt(parts[1], 10) - 1; // Mês começa em 0
            const year = parseInt(parts[2], 10);

            // Verifica se a data é válida
            const date = new Date(year, month, day);
            if (date.getDate() === day && date.getMonth() === month && date.getFullYear() === year) {
                return date; // Retorna o objeto Date se for uma data válida
            }
        }
        return null; // Retorna null se não for uma data válida
    }


    const getAllOpportunitiesPanels = async (page?: number, take?: number) => {
        try {
            toggleLoading(true);
            let text = "all"

            await GetAllOpportunitiesPanelsAPI(company.id, page ?? 1, take ? take : 7, text).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    var values = resp.data.items as OpportunitiesPanelsModel[];
                    values.forEach(element => {
                        element.dateFormat = formatOnlyDate(element.created.toString());
                        element.resultFormat = ResultEnum[element.result].toString();
                    });
                    setOpportunities(resp.data.items);
                    setTotal(resp.data.total);
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const deleteOpportunitiesPanels = async (opportunitiesPanelsId: string) => {
        try {
            toggleLoading(true);

            await DeleteOpportunitiesPanelsAPI(opportunitiesPanelsId, company.id).then((resp: IResponseProps) => {
                if (resp.statusCode === 200) {
                    getAllOpportunitiesPanels();
                }
            }).finally(() => {
                toggleLoading(false);
            });
        } catch (error: any) {
            toast.error(error);
            toggleLoading(false);
        }
    }

    const downloadOpportunitiesPanels = async (panelId: string, name: string) => {
        try {
            toggleLoading(true);
            await DownloadGrantsDocumentAPI(company.id, panelId, false).then((resp: any) => {
                const url = window.URL.createObjectURL(new Blob([resp]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Resumo Painel de Oportunidades ${name}.docx`);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            })
        } catch (error: any) {
            toast.error(error);
        } finally {
            toggleLoading(false);
        }
    }

    const columnsOpotunities: any[] = [];
    OpportunitiesPanelsColumns.forEach(panel => {
        const filterNPanel = Array.from(new Set(opportunities.map(x => x)));
        if (panel.id == 'number') {
            columnsOpotunities.push({
                title: panel.name,
                dataIndex: panel.name,
                key: panel.id,
                filters: filterNPanel.map(Npanel => ({
                    text: Npanel,
                    value: Npanel,
                })),
                onFilter: (value: string | number, record: { [key: string]: any }) => {
                    const fieldValue = record[panel.id];
                    if (fieldValue == null) {
                        return false;
                    }
                    return String(fieldValue) === String(value);
                },
                render: (text: any, row: { [x: string]: any; id: string; }) => {
                    return (
                        <Link to={"/opportunitiesPanels/LinesPresentation/" + row.id}>
                            {row[panel.id]}
                        </Link>
                    )
                }

            })
        } else {
            columnsOpotunities.push({
                title: panel.name,
                dataIndex: panel.name,
                key: panel.id,
                sorter: (a: any, b: any) => {
                    debugger
                    const aValue = a[panel.id];
                    const bValue = b[panel.id];
                    if (aValue == null && bValue == null) return 0;
                    if (aValue == null) return 1;
                    if (bValue == null) return -1;

                    if (!isNaN(aValue) && !isNaN(bValue)) {
                        return aValue - bValue;
                    }
                    const dateA = parseDate(aValue);
                    const dateB = parseDate(bValue);

                    if (dateA && dateB) {
                        return dateA.getTime() - dateB.getTime();
                    }



                    return String(aValue).localeCompare(String(bValue));
                },
                render: (text: any, row: { [x: string]: any; id: string; }) => {
                    return (
                        row[panel.id]
                    );
                }
            });
        }
    });

    columnsOpotunities.push({
        title: 'Ações',
        key: 'actions',
        width: '120px',
        dataIndex: 'actions',
        render: (text: any, row: { [x: string]: any; id: string; }) => (
            <div className='d-flex align-item-center h-100 w-100 last-column-action'>
                <div className='d-flex align-items-center justify-content-center'>

                    <Link to={"/opportunitiesPanels/linesPresentation/" + row.id}><EditOutlined className="cursor-pointer me-2 icon" style={{ color: '#0958D9', fontSize: '18px' }} /></Link>
                    <Button
                        type="link"
                        onClick={() => { downloadOpportunitiesPanels(row.id, row.name); }}
                        className='bnt p-0'
                    > <FileWordOutlined className="cursor-pointer me-2 icon" style={{ color: 'black', fontSize: '18px', marginTop: '4px'}} /> </Button>

                    <Button
                        type="link"
                        onClick={() => { setItemToDelete(row.id); toggleShowModalDelete(); }}
                        className='btn p-0'
                    ><DeleteOutlined className="cursor-pointer icon" style={{ color: '#CF1322', fontSize: '18px' }} /></Button>
                </div>
            </div>
        )
    });

    const handleShowSizeChange = (current: any, size: any) => {
        debugger
        setTake(size);
        setCurrentPage(current);
        getAllOpportunitiesPanels(current, size);
    };


    useEffect(() => {
        getAllOpportunitiesPanels();
    }, []);
    useEffect(() => {
        if (deleteResponse && itemToDelete !== "") {
            deleteOpportunitiesPanels(itemToDelete);
            setItemToDelete("");
            setDeleteResponse(false);
        } else if (itemToDelete != "") {
            setItemToDelete("");
        }
    }, [deleteResponse]);

    return (
        <div className='card ml-2 mr-2'>
            <ModalDelete show={showModalDelete} toggleShow={toggleShowModalDelete} setResponse={setDeleteResponse} />
            {loading && <Loader />}
            <ModalOpportunitiesPanels
                show={showModal}
                toggleShowModal={toggleShowModal}
                companyId={company.id} />
            <CardHeader
                pageName={"Painel de Oportunidades"}
                hasPageBefore={false} />
            <div className='card-body'>
                <Table<OpportunitiesPanelsModel>
                    columns={columnsOpotunities}
                    dataSource={opportunities}
                    pagination={{
                        total: total,
                        showSizeChanger: true,
                        showTotal: (total) => <Text>Total {total} items</Text>,
                        pageSize: take,
                        current: currentPage,
                        onShowSizeChange: (page, size) => handleShowSizeChange(page, size),
                        onChange: (page, size) => {
                            handleShowSizeChange(page, size);
                        },

                    }}
                />
                <Button type="primary" variant="solid" className='ant-button-blue w-100 mt-2 d-flex justify-content-center' onClick={toggleShowModal}>

                    <PlusOutlined />   Adicionar Novo Painel de Oportunidades

                </Button>
            </div>
        </div>
    )
}